import { Stack, Typography } from "@mui/material";
import { useCallback } from "react";
import { sxConfig } from "./HeaderSplitCell.style";
import { useTranslation } from "react-i18next";

export const HeaderSplitCell = ({
  getSortIcon,
  handleSort,
  headerItem
}: {
  getSortIcon: any;
  handleSort: any;
  headerItem: any;
}) => {
  const { t } = useTranslation();

  const onSort = useCallback(
    (sortBy: string) => () => handleSort(headerItem, sortBy),
    [handleSort, JSON.stringify(headerItem)]
  );

  const getSortTypeIcon: Function = useCallback(
    (sortBy: string): JSX.Element => getSortIcon(headerItem, sortBy),
    [getSortIcon, JSON.stringify(headerItem)]
  );

  return (
    <Stack sx={sxConfig.wrapper}>
      <Stack sx={[sxConfig.heading, headerItem.headingStyle]}>
        <Typography sx={sxConfig.headingText}>
          {t(`tableHeaders.${headerItem.label || headerItem.id}`)}
        </Typography>
      </Stack>
      <Stack sx={sxConfig.subtitleWrapper}>
        {headerItem?.columns?.map((colum: any) => {
          return (
            <Stack
              key={colum.id}
              onClick={onSort(colum.id)}
              sx={[sxConfig.subtitle, colum.headerSX]}
              data-testid={"headerSplitSubtitle" + colum.id}
            >
              <Typography sx={sxConfig.subtitleText}>
                {t(`header.headerSplitCell.${colum.label || colum.id}`)}
              </Typography>
              {getSortTypeIcon(colum.id)}
            </Stack>
          );
        })}
      </Stack>
    </Stack>
  );
};
